import React from "react";

export default function AudioCell({ url }) {
  const [src, setSrc] = React.useState(null);
  const [failed, setFailed] = React.useState(false);

  React.useEffect(() => {
    let alive = true;
    let objURL = null;

    (async () => {
      try {
        setFailed(false);
        const resp = await fetch(url); // sem headers extras
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        const blob = await resp.blob();
        objURL = URL.createObjectURL(blob);
        if (alive) setSrc(objURL);
      } catch (e) {
        if (alive) setFailed(true);
      }
    })();

    return () => {
      alive = false;
      if (objURL) URL.revokeObjectURL(objURL);
    };
  }, [url]);

  // Fallback: se falhou, mostra link p/ download
  if (failed) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        download
        title="Baixar áudio (.wav)"
      >
        Baixar áudio (.wav)
      </a>
    );
  }

  // Ainda carregando
  if (!src) return <span>Carregando áudio…</span>;

  // Deu certo: player
  return (
    <audio
      controls
      preload="none"
      src={src}
      style={{ width: 200 }}
      controlsList="nodownload"
      onContextMenu={(e) => e.preventDefault()}
    >
      Seu navegador não suporta o elemento de áudio.
    </audio>
  );
}